@if (isOpen$ | async) {
  @if (model$ | async; as model) {
    <div
      class="absolute inset-0 bg-black/50 flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in"
      (click)="onClose()"
    >
      <div
        class="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden animate-slide-up"
        (click)="$event.stopPropagation()"
      >
        <!-- Header -->
        <div class="p-6 border-b border-gray-100 bg-gradient-to-r from-gray-50 to-white">
          <div class="flex justify-between items-start">
            <div>
              <span class="inline-block px-2.5 py-1 text-xs font-medium bg-brand/10 text-brand rounded-full mb-2">
                {{ model.category }}
              </span>
              <h3 class="text-xl font-bold text-gray-800">
                {{ model.name }}
              </h3>
            </div>
            <button
              (click)="onClose()"
              class="text-gray-400 hover:text-gray-600 cursor-pointer p-1 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <lucide-icon [img]="icons.X" class="w-5 h-5"></lucide-icon>
            </button>
          </div>
        </div>

        <!-- Content -->
        <div class="p-6 space-y-5">
          <!-- Best For -->
          <div class="flex gap-3">
            <div class="flex-shrink-0 w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center">
              <lucide-icon [img]="icons.Target" class="w-4 h-4 text-green-600"></lucide-icon>
            </div>
            <div>
              <h4 class="text-sm font-bold text-gray-700 mb-1">Best For</h4>
              <p class="text-sm text-gray-600">{{ model.metadata.bestFor }}</p>
            </div>
          </div>

          <!-- Core Philosophy -->
          <div class="flex gap-3">
            <div class="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
              <lucide-icon [img]="icons.BookOpen" class="w-4 h-4 text-blue-600"></lucide-icon>
            </div>
            <div>
              <h4 class="text-sm font-bold text-gray-700 mb-1">Core Philosophy</h4>
              <p class="text-sm text-gray-600">{{ model.metadata.corePhilosophy }}</p>
            </div>
          </div>

          <!-- Typical Structure -->
          <div class="flex gap-3">
            <div class="flex-shrink-0 w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center">
              <lucide-icon [img]="icons.List" class="w-4 h-4 text-purple-600"></lucide-icon>
            </div>
            <div class="flex-1">
              <h4 class="text-sm font-bold text-gray-700 mb-2">Typical Structure</h4>
              <div class="space-y-1.5">
                @for (step of model.metadata.typicalStructure; track step; let i = $index) {
                  <div class="flex items-start gap-2">
                    <span class="flex-shrink-0 w-5 h-5 bg-gray-100 rounded-full text-xs font-medium text-gray-600 flex items-center justify-center">
                      {{ i + 1 }}
                    </span>
                    <span class="text-sm text-gray-600">{{ step }}</span>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="p-6 pt-0">
          <button
            (click)="onClose()"
            class="w-full px-4 py-3 text-gray-700 font-medium bg-gray-100 rounded-xl hover:bg-gray-200 transition-colors cursor-pointer"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  }
}
